// extracted by mini-css-extract-plugin
export var dogschoolsearchinner = "SectionDogSchoolSearch-module--dogschoolsearchinner--97ef4";